/**
 * Shared styles for node header buttons
 */

import type React from 'react';

export const nodeHeaderButton: React.CSSProperties = {
  width: 18,
  height: 18,
  borderRadius: '50%',
  border: 'none',
  background: 'transparent',
  color: '#6b7280',
  cursor: 'pointer',
  fontSize: 11,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0
};

export const nodeHeaderButtonActive: React.CSSProperties = {
  ...nodeHeaderButton,
  background: '#4b5563',
  color: '#ffffff'
};

export const nodeHeaderButtonError: React.CSSProperties = {
  ...nodeHeaderButton,
  background: '#dc2626',
  color: '#ffffff'
};

export const nodeHeaderButtonActiveError: React.CSSProperties = {
  ...nodeHeaderButton,
  background: '#4b5563',
  color: '#dc2626'
};
